import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2547b496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "punchout-dialog" }

import {PunchoutDetails} from '@/common/api';
    import {clickOutsideSelector} from '@malt/dom';
    import {useTranslation} from '@malt/vue3-use';
    import {PropType, computed, onBeforeUnmount, onMounted, ref} from 'vue';

    interface DialogContent {
        title: string;
        subtitle?: string;
        description: string;
        cta?: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
        punchoutDetails: {
            type: Object as PropType<PunchoutDetails>,
        },
        isSessionActive: {type: Boolean},
    },
  emits: ["dialogClosed"],
  setup(__props, { emit }) {

const props = __props;

    

    const {msg, $requireMsg} = useTranslation();
    

    $requireMsg('navbar.punchout.badge.*');
    const baseKey = `navbar.punchout.badge.${props.isSessionActive ? 'connected' : 'disconnected'}`;
    const appName = computed(() => props.punchoutDetails?.procurementAppName);
    const content = ref<DialogContent>(
        props.isSessionActive
            ? {
                  title: msg(`${baseKey}.title`, appName.value),
                  description: msg(`${baseKey}.content`, appName.value, appName.value),
              }
            : {
                  title: msg(`${baseKey}.title`, appName.value),
                  subtitle: msg(`${baseKey}.subtitle`, appName.value),
                  description: msg(`${baseKey}.content`),
                  cta: msg(`${baseKey}.cta`, appName.value),
              },
    );

    function handleClick(e: Event) {
        if (clickOutsideSelector(e, `.punchout-dialog, .punchout-header`)) {
            emit('dialogClosed');
        }
    }

    onMounted(() => {
        document.addEventListener('click', handleClick);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleClick);
    });

return (_ctx: any,_cache: any) => {
  const _component_VJoyHighlight = _resolveComponent("VJoyHighlight")!
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyPanel = _resolveComponent("VJoyPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VJoyPanel, { padding: "large" }, _createSlots({
      "panel-title": _withCtx(() => [
        _createTextVNode(_toDisplayString(content.value.title), 1)
      ]),
      "panel-body": _withCtx(() => [
        _createVNode(_component_VJoyHighlight, {
          "display-icon": true,
          level: __props.isSessionActive ? 'success' : 'warning'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(content.value.description), 1)
          ]),
          _: 1
        }, 8, ["level"]),
        (content.value.cta)
          ? (_openBlock(), _createBlock(_component_VJoyButton, {
              key: 0,
              class: "punchout-dialog__cta",
              label: content.value.cta,
              size: "small",
              variant: "main",
              href: __props.punchoutDetails?.procurementAppUrl
            }, null, 8, ["label", "href"]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (content.value.subtitle)
        ? {
            name: "panel-subtitle",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(content.value.subtitle), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1024)
  ]))
}
}

})